import * as dayjs from 'dayjs'
import { KeyPair } from '@/types/KeyPair'

export interface IModelBase {
  id: number
  created_at?: string
  updated_at?: string
}

export default abstract class ModelBase {
  id = 0
  created_at?: Date
  updated_at?: Date

  constructor(defaults?: IModelBase) {
    if (!defaults) {
      return
    }
    this.id = defaults.id || 0
    this.created_at = defaults.created_at ? dayjs(defaults.created_at).toDate() : undefined
    this.updated_at = defaults.updated_at ? dayjs(defaults.updated_at).toDate() : undefined
  }

  abstract toParams(): KeyPair

  get persisted(): boolean {
    return !!this.id
  }

  get createdAtNumber(): number {
    return dayjs(this.created_at).toDate().getTime()
  }

  get createdAtString(): string {
    return dayjs(this.created_at).format('YYYY/MM/DD HH:mm')
  }

  get updatedAtNumber(): number {
    return dayjs(this.updated_at).toDate().getTime()
  }

  get updatedAtString(): string {
    return dayjs(this.updated_at).format('YYYY/MM/DD HH:mm')
  }
}
